<template>
  <footer class="footer">

    <div class="container w">
      <!-- 友情链接 -->
      <div class="friend-links">
        <span>友情链接：</span>
        <a href="https://kjc.jit.edu.cn/" target="_blank" rel="noopener noreferrer">金陵科技学院科技处、科技服务中心</a>
      </div>
      <!-- 版权信息 -->
      <div class="copyright">
        <p>
          Copyright©2022-2025 金陵科技学院 All Right Reserved
        </p>
        <p>
          版权所有：金陵科技学院科技处 电话：025-86188106 86188195 邮编：211169 电子邮件：kjc@jit.edu.cn
        </p>
        <p>
          地址:南京市江宁区弘景大道99号
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'MyFooter'
}
</script>

<style scoped lang='less'>
@import url("../assets/styles/variables.less");

.footer {
  overflow: hidden;
  background-color: #4877E2;
  padding-top: 20px;
  margin-top: 20px;
  .friend-links {
    text-align: center;
    color: #fff;
    font-size: 15px;
    margin-bottom: 15px;
    a {
      color: #fff;
    }
  }
  .copyright {
    height: 120px;
    padding-top: 20px;
    text-align: center;
    color: #fff;
    font-size: 15px;
    p {
      line-height: 1;
      margin-bottom: 20px;
    }
    a {
      color: #fff;
      line-height: 1;
      padding: 0 10px;
      border-right: 1px solid #fff;
      &:last-child {
        border-right: none;
      }
    }
  }
}
</style>

